import React from 'react';

import { Popper, Paper, ClickAwayListener } from '@mui/material';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

import ChevronDown from 'components/SvgComponents/icons/ChevronDown';
import ChevronUp from 'components/SvgComponents/icons/ChevronUp';

import { FilterSelectButton } from './filter-select-button';

const Popper_Styled = styled(Popper)(({ theme }) => ({
  zIndex: theme.zIndex.modal,
}));

export const FilterSelector = ({
  anchorEl,
  children,
  disabled,
  handleToggle,
  isOpen,
  key,
  label,
  placement = 'bottom-end',
}) => {
  const POPPER_ID = 'filter-selector';

  return (
    <>
      <FilterSelectButton
        aria-haspopup="true"
        aria-owns={POPPER_ID}
        disabled={disabled}
        endIcon={isOpen ? <ChevronUp width={16} /> : <ChevronDown width={16} />}
        onClick={handleToggle}
      >
        {label}
      </FilterSelectButton>

      <Popper_Styled
        autoFocus={false}
        id={POPPER_ID}
        key={key || POPPER_ID}
        open={isOpen}
        anchorEl={anchorEl}
        placement={placement}
      >
        <ClickAwayListener onClickAway={handleToggle}>
          <Paper sx={{ borderRadius: 4 }}>{children}</Paper>
        </ClickAwayListener>
      </Popper_Styled>
    </>
  );
};

FilterSelector.propTypes = {
  anchorEl: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  handleToggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  key: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placement: PropTypes.string,
};
